<template>
	<BaseCenteredPage v-if="isLoading">
		<BaseIcon name="mono/load" class="my-auto w-24 h-24" />
	</BaseCenteredPage>
	<SessionJoinWorkspaceToView
		v-else-if="!isAlreadyWorkspaceMember && workspaceUserCanJoin"
		:workspaceUserCanJoin="workspaceUserCanJoin"
		@joined="$emit('joined')"
	/>
	<SessionCannotLoad v-else />
</template>

<script>
import {defineAsyncComponent} from 'vue'

import {useCanUserJoinWorkspace} from 'shared/composables/useCanUserJoinWorkspace'

export default {
	name: 'Session404',
	components: {
		SessionJoinWorkspaceToView: defineAsyncComponent(() => import('shared/views/SessionJoinWorkspaceToView.vue')),
		SessionCannotLoad: defineAsyncComponent(() => import('shared/views/SessionCannotLoad.vue')),
	},
	emits: ['joined'],
	setup() {
		const {workspaceUserCanJoin, isLoading, isAlreadyWorkspaceMember} = useCanUserJoinWorkspace()
		return {
			workspaceUserCanJoin,
			isLoading,
			isAlreadyWorkspaceMember,
		}
	},
}
</script>
